<template lang="pug">
  .b2b-filters-profile-parties
    b2b-filters-component(
      :filter-options='filterOptions',
      :default-filter='filterOptions.tradeName',
      @filters-query='filtersHaveChanged',
      :show-date-picker='false',
      :initial-tags='initialTags')
</template>

<script>
import { mapGetters } from 'vuex'
import B2bFiltersComponent from '@/components/B2bFiltersComponent'
import filters from './filtros-my-parties'

export default {
  name: 'b2b-filters-profile-parties',
  data () {
    return {
      filterOptions: {},
      params: {},
      dateRange: [],
      defaultParams: {},
      initialTags: [],
      initialRange: []
    }
  },

  computed: {
    ...mapGetters([
      'getMyPartiesQueryParams',
      'optionsFilterService',
      'countries'
    ])
  },

  components: {
    B2bFiltersComponent
  },

  methods: {
    filtersHaveChanged (params) {
      if (this.dateRange.length === 2) {
        params.closeDateTimeFrom = this.dateRange[0]
        params.closeDateTimeTo = this.dateRange[1]
      }
      this.params = params
      this.$emit('filters-changed', this.params)
    },

    getQueryParams () {
      return JSON.parse(JSON.stringify(this.params))
    },

    filterFilterToAdd (filterToAdd) {
      return x => x.value === this.params[filterToAdd.prop]
    },
    filterTags (filterToAdd) {
      return t => t.prop === filterToAdd.prop
    }
  },

  async created () {
    const self = this
    this.filterOptions = JSON.parse(JSON.stringify(filters.filters))
    this.filterOptions.projectId.options = []
    this.filterOptions.countryId.options = []

    // Internacionalización de etiquetas
    try {
      for (const f in this.filterOptions) {
        if (this.filterOptions[f].placeholder) {
          this.filterOptions[f].placeholder = this.$i18n.t(
            this.filterOptions[f].placeholder
          )
        }
        if (this.filterOptions[f].value) {
          this.filterOptions[f].value = this.$i18n.t(this.filterOptions[f].value)
        }
        if (this.filterOptions[f].options) {
          for (const o of this.filterOptions[f].options) {
            o.name = this.$i18n.t(o.name)
          }
        }
      }
    } catch (error) {
      console.error(error)
    }

    // Cargar opciones
    const projectos = this.optionsFilterService
    if (projectos) {
      for (const p of projectos) {
        this.filterOptions.projectId.options.push({
          value: p.id,
          name: p.name
        })
      }
    }
    const paises = this.countries
    if (paises) {
      for (const p of paises) {
        this.filterOptions.countryId.options.push({
          value: p.id,
          name: p.name
        })
      }
    }

    // Cargar valores almacenados
    let savedQueryParams = this.getMyPartiesQueryParams
    if (!savedQueryParams) {
      savedQueryParams = {}
    }
    this.params = { ...this.defaultParams, ...savedQueryParams }
    this.initialTags = []
    for (const property in this.params) {
      const findFilter = function (filterName) {
        let filter = null
        for (const f in self.filterOptions) {
          if (self.filterOptions[f].prop === filterName) {
            filter = self.filterOptions[f]
            break
          }
        }
        return filter
      }
      const filterToAdd = findFilter(property)
      if (filterToAdd) {
        if (filterToAdd.componente === 'select') {
          const option = filterToAdd.options.find(this.filterFilterToAdd(filterToAdd))
          if (option) {
            filterToAdd.userValue = option.name
            filterToAdd.query = option.value
            this.initialTags.push(filterToAdd)
          }
        } else if (
          filterToAdd.componente === 'date' &&
          filterToAdd.tipo === 'daterange'
        ) {
          const tagFound = this.initialTags.find(this.filterTags(filterToAdd))
          if (tagFound) {
            if (property.endsWith('From')) {
              tagFound.query[0] = this.params[filterToAdd.prop]
            } else {
              tagFound.query[1] = this.params[filterToAdd.prop]
            }
          } else {
            filterToAdd.query = [null, null]
            if (property.endsWith('From')) {
              filterToAdd.query[0] = this.params[filterToAdd.prop]
            } else {
              filterToAdd.query[1] = this.params[filterToAdd.prop]
            }
            this.initialTags.push(filterToAdd)
          }
        } else {
          filterToAdd.query = this.params[filterToAdd.prop]
          this.initialTags.push(filterToAdd)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .ods-input__prefix {
  height: 72px !important;
}
::v-deep .ods-input__suffix {
  height: 72px !important;
}

</style>
